import React, {useEffect, useState} from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import { StateKeys } from "../../redux/states/main.state";
import { RouteComponentProps, useParams } from "react-router";
import {
  AppPageScrollDownLoadMore,
  AppState,
} from "../../services/app.service";
import Main from "../../redux/actions/main.action";
import ApiEndpoint from "../../services/api.endpoint.service";
import Loader from "../../components/Loader";
import {ClassResponse, ContentProviderResponse} from "../../services/api.response.service";
import ClassesCardVList from "../../components/ClassesCardVList";
import { RouteEndpoints } from "../../services/route.service";
import NoData from "./NoData";
import Languages from "../../components/Languages";
import {Mixpanel} from "../../services/mixpanel";

function CategoryClasses({ location }: RouteComponentProps) {
  // const id = location.pathname.replace("/ct/", "");
  let { id } = useParams<{ id: string }>();
  let { link } = useParams<{ link: string }>();
  const dispatch = useDispatch();
  const state = useSelector((state: IRootState) => state.main);
  const classes = state[StateKeys.CATEGORY_CLASSES];

    const stateAll = useSelector((state: IRootState) => state);
    const currentUser = stateAll.setting.user!;

    const [mp, setMp] = useState<boolean>(false);
    useEffect(() => {
        if (!mp && (classes.data[0] as ClassResponse)?.category?.name) {
            Mixpanel.track('Category Details View', {
                'with': currentUser?.id ? "Auth" : "Guest",
                'user_id': currentUser?.id,
                'category_id': id,
                'category_name': (classes.data[0] as ClassResponse)?.category?.name,
            });
            setMp(true);
        }
    }, [classes]);


    let getCategoryId = () => {
        let theId = String((classes.data[0] as ClassResponse).category?.id ?? "")
        if (theId && theId !== "" && theId !== undefined && theId !== 'undefined' && theId !== null) {
            id = theId
        }

        if (id && id !== "" && id !== undefined && id !== 'undefined' && id !== null) {
            return id
        }
        // if (link && link !== "") {
        //       return link
        // }
        // return (String((activeClass.data as ClassResponse).id));
        return '';
    }


  useEffect(() => {
    if (
      // classes.pageState !== AppState.LOADED ||
      // classes.data.length === 0
      //   ||
      // (classes.pageState === AppState.LOADED &&
      //   classes.data.length > 0 &&
      //   String((classes.data[0] as ClassResponse).category?.id ?? "") !== getCategoryId())
        true
    ) {
      dispatch(
        Main.postPaginatedPageDataSuccess({
          stateKey: StateKeys.CATEGORY_CLASSES,
          data: [],
          clear: true,
        })
      );
      dispatch(
        Main.getPaginatedPageData({
          stateKey: StateKeys.CATEGORY_CLASSES,
          apiEndpoint: ApiEndpoint.CATEGORY_CLASSES((link ?? id)),
          previousPage: 0,
        })
      );
    }
  }, [id]);

  const loadMore = () => {
    // @ts-ignore
    if (
      window.innerHeight + document.documentElement.scrollTop ===
        // @ts-ignore
        document.scrollingElement.scrollHeight &&
      classes.hasMore &&
      (classes.pageState !== AppState.LOADING || // @ts-ignore
        classes.pageState !== AppState.LOADING_MORE)
    ) {
      dispatch(
        Main.getPaginatedPageData({
          stateKey: StateKeys.CATEGORY_CLASSES,
          apiEndpoint: ApiEndpoint.CATEGORY_CLASSES((link ?? id)),
          previousPage: classes.currentPage!,
        })
      );
    }
  };

  return (
    <div
      className="content-page scroller-hide"
      onScroll={(e) => AppPageScrollDownLoadMore(e, loadMore)}
    >
      <Row>
        {(classes.pageState === AppState.LOADED ||
          classes.pageState === AppState.LOADING_MORE) && (
          <>
            {classes.data.length ? (
                <div className="content-card">
                    <ClassesCardVList
                        data={classes.data as Array<ClassResponse>}
                        state={classes.pageState}
                        title={
                            (classes.data[0] as ClassResponse).category?.name ===
                            "Test Prep"
                                ? "testPrepCat"
                                : (classes.data[0] as ClassResponse).category?.name
                                    .toLowerCase()
                                    .concat("Cat")
                        }
                    />
                </div>
            ) : (
              <NoData
                title="noClasses"
                link={RouteEndpoints.CATEGORIES}
                btnText="backToCat"
              />
            )}
          </>
        )}
        <Col md={12}>
          {classes.hasMore &&
            !(
              classes.pageState === AppState.LOADING ||
              classes.pageState === AppState.LOADING_MORE
            ) && (
              <div
                className={`w-100 text-center shadow-xss rounded-xxl border-0 px-3`}
              >
                <button
                  className="text-decoration-none btn btn-primary"
                  onClick={() => loadMore()}
                >
                  <Languages langKey="loadMore" />
                </button>
              </div>
            )}
        </Col>
        <Col md={12}>
          {(classes.pageState === AppState.LOADING_MORE ||
            classes.pageState === AppState.LOADING) && (
            <Loader noCard imageLoader />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default CategoryClasses;
